import type { Page, AuditEntry } from "@/lib/api";
import { PaginationControls } from "./PaginationControls";
import { Input } from "./ui/input";

interface Props {
  data?: Page<AuditEntry>; isLoading: boolean;
  q: string; onQ: (v: string) => void;
  from: string; onFrom: (v: string) => void;
  to: string; onTo: (v: string) => void;
  page: number; size: number; onPage: (p: number) => void; onSize: (s: number) => void;
}
export function AuditTable({ data, isLoading, q, onQ, from, onFrom, to, onTo, page, size, onPage, onSize }: Props) {
  const items = data?.items ?? [];
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2 items-center">
        <Input data-testid="audit-search" value={q} onChange={(e) => onQ(e.target.value)} placeholder="Rechercher action, entité, cible…" className="h-8 text-sm max-w-xs" />
        <input data-testid="audit-from" type="date" value={from} onChange={(e) => onFrom(e.target.value)} className="border border-slate-200 rounded h-8 px-2 text-xs" aria-label="Date début" />
        <input data-testid="audit-to" type="date" value={to} onChange={(e) => onTo(e.target.value)} className="border border-slate-200 rounded h-8 px-2 text-xs" aria-label="Date fin" />
      </div>
      <div className="border border-slate-200 rounded overflow-hidden">
        {isLoading ? <div className="py-10 text-center text-slate-500 text-sm">Chargement…</div> : (
          <table className="w-full text-sm">
            <thead className="text-xs uppercase tracking-wide text-slate-500 bg-slate-50 border-b border-slate-200">
              <tr><th className="text-left px-3 py-2">Date</th><th className="text-left">Acteur</th><th className="text-left">Module</th><th className="text-left">Action</th><th className="text-left">Cible</th><th className="text-left pr-3">IP</th></tr>
            </thead>
            <tbody>
              {!items.length && <tr><td colSpan={6} className="py-8 text-center text-slate-500">Aucune entrée.</td></tr>}
              {items.map((a) => (
                <tr key={a.id} className="border-b border-slate-100">
                  <td className="px-3 py-1.5 text-xs text-slate-500">{a.createdAt ? new Date(a.createdAt).toLocaleString("fr-FR") : "·"}</td>
                  <td className="text-slate-700">{a.actorEmail ?? "·"}</td>
                  {/* v8 ignore start -- actorRole est non-nullable (type AuditEntry); fallback "·" inatteignable */}
                  <td className="text-xs">{a.actorRole ?? "·"}</td>
                  {/* v8 ignore stop */}
                  <td className="text-xs font-medium">{a.action}</td>
                  <td className="text-xs text-slate-600">{a.targetType}{a.targetId ? ` · ${a.targetId.slice(0, 8)}` : ""}</td>
                  <td className="text-xs text-slate-400 pr-3">{a.ip ?? "·"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <PaginationControls page={page} size={size} total={data?.total ?? 0} onPageChange={onPage} onSizeChange={onSize} />
      </div>
    </div>
  );
}
